<div
  echarts
  [options]="chartOption"
  class="sea-chart"
  (chartInit)="onChartInit($event)"
  (chartClick)="chartClick($event)"
  (chartRestore)="chartRestore($event)"
  (chartDblClick)="chartDblClick($event)"
  [style.height]="computedHeight"
></div>
